<template>
  <div style="position: relative">
    <h2 class="text-color page-title">پلاک خودرو</h2>
    <div class="plate-container">
      <div>
        <div class="plate">
          <div class="text-color">ایران</div>
          <div class="iran-digit">
            <input
              id="txt-iran-digit"
              type="tel"
              class="input"
              maxlength="2"
              v-model="iranDigit"
            />
          </div>
          <div class="three-digit">
            <input
              id="txt-three-digit"
              type="tel"
              class="input"
              maxlength="3"
              v-model="threeDigit"
            />
          </div>
          <div class="plate-alphabet">
            <select
              id="cmb-plate-alphabet"
              name="plate-alphabet"
              class="input"
              v-model="plateAlphabet"
            >
              <option value="ب">ب</option>
              <option value="ج">ج</option>
              <option value="د">د</option>
              <option value="س">س</option>
              <option value="ص">ص</option>
              <option value="ط">ط</option>
              <option value="ق">ق</option>
              <option value="م">م</option>
              <option value="ن">ن</option>
              <option value="و">و</option>
              <option value="ه">ه‍</option>
              <option value="ی">ی</option>
              <option value="ا">الف</option>
              <option value="پ">پ</option>
              <option value="ت">ت</option>
              <option value="ث">ث</option>
              <option value="ز">ز</option>
              <option value="ژ">ژ</option>
              <option value="ش">ش</option>
              <option value="ع">ع</option>
              <option value="ف">ف</option>
              <option value="ک">ک</option>
              <option value="گ">گ</option>
              <option value="D">D</option>
              <option value="S">S</option>
            </select>
          </div>
          <div class="two-digit">
            <input
              id="txt-two-digit"
              type="tel"
              class="input"
              maxlength="2"
              v-model="twoDigit"
            />
          </div>
        </div>
      </div>
      <div>
        <input type="button" value="ارسال" @click="savePlate()" />
      </div>
    </div>
    <div class="error-message" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="loader" v-if="loader">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../service";

export default {
  name: "plate",
  props: {
    carId: {
      type: Number,
      required: true,
    },
    redirect: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errorMessage: null,
      loader: false,
      iranDigit: null,
      threeDigit: null,
      plateAlphabet: null,
      twoDigit: null,
    };
  },
  methods: {
    savePlate: function() {
      if (
        !this.iranDigit ||
        !this.threeDigit ||
        !this.plateAlphabet ||
        !this.twoDigit
      ) {
        this.validationMessage = "وارد کردن پلاک خودرو اجباری است.";
        return;
      }

      this.errorMessage = null;
      const entity = {
        CarId: this.carId,
        LicensePlateIranDigits: this.iranDigit,
        LicensePlateThreeDigits: this.threeDigit,
        LicensePlateAlphabet: this.plateAlphabet,
        LicensePlateFirstTwoDigits: this.twoDigit,
      };

      this.loading = true;
      api
        .savePlate(entity)
        .then((response) => {
          if (response.data && response.data.Status === 200) {
            this.$router.replace(`/${this.redirect}/${this.carId}`);
          } else {
            if (
              response.data &&
              response.data.Messages &&
              response.data.Messages.length > 0
            ) {
              this.errorMessage = response.data.Messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage =
            "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.page-title {
  text-align: center;
  padding: 15px;
  border-bottom: solid 1px #09389f;
  margin: 0 20px 10px 20px;
}

.plate-container {
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.plate-input {
  flex: 1;
}

.plate-container input[type="button"] {
  border: solid 1px #09389f;
  background-color: #09389f;
  padding: 8px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px 10px 0;
}

.error-message {
  margin: 0 20px 10px 20px;
}

.loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(64, 64, 64, 0.5);
}

.plate {
  display: flex;
  align-items: center;
}

.two-digit input,
.three-digit input,
.iran-digit input {
  text-align: center;
}

.two-digit {
  flex: 2;
  margin: 0 2px;
}

.plate-alphabet {
  flex: 3;
  margin: 0 2px;
}

.plate-alphabet select {
  padding: 7px;
}

.three-digit {
  flex: 4;
  margin: 0 2px;
}

.iran-digit {
  flex: 2;
  margin: 0 7px 0 2px;
}
</style>
